export default __webpack_public_path__ + "static/og_hor_color-f6f02ba10a016c39b152ae51de479a9b.png";